import { buildUrl, createRequest } from './common/httpUtils'

const LOGIN_CONFIGURATION_PATH = '/api/v1/office/login_configuration'

export type OfficeLoginConfiguration = {
  samlLoginEnabled: boolean
  passwordLoginEnabled: boolean
}

const getOfficeHostname = (): string => (
  process.env.REACT_APP_HOSTNAME || window.location.hostname
)

const parseLoginConfiguration = (value: unknown): OfficeLoginConfiguration => {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    throw new Error('Login configuration is invalid')
  }

  const response = value as Record<string, unknown>
  const samlLoginEnabled = response.saml_login_enabled
  const passwordLoginEnabled = response.password_login_enabled

  if (
    typeof samlLoginEnabled !== 'boolean'
    || typeof passwordLoginEnabled !== 'boolean'
  ) {
    throw new Error('Login configuration is invalid')
  }

  return {
    samlLoginEnabled,
    passwordLoginEnabled,
  }
}

export const getOfficeLoginConfiguration = async (
  signal?: AbortSignal,
): Promise<OfficeLoginConfiguration> => {
  const endpoint = new URL(buildUrl(LOGIN_CONFIGURATION_PATH))
  endpoint.searchParams.set('hostname', getOfficeHostname())

  const response = await fetch(
    createRequest(endpoint.toString(), 'GET', false),
    { signal },
  )

  if (!response.ok) throw new Error('Failed to load login configuration')

  const responseBody: unknown = await response.json()
  return parseLoginConfiguration(responseBody)
}
